import { render } from "./CookiesTable.vue?vue&type=template&id=54fe9514&scoped=true&ts=true"
import script from "./CookiesTable.vue?vue&type=script&lang=ts"
export * from "./CookiesTable.vue?vue&type=script&lang=ts"

import "./CookiesTable.vue?vue&type=style&index=0&id=54fe9514&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fe9514"]])

export default __exports__